import Filter from './record'

import * as Icons from 'components/Utils/Icons'

export const ARCHIVED_NOTES = Filter({
  id: 'archived',
  name: 'Trash',
  icon: Icons.DeleteIcon,
})

export const BOOKMARKED_NOTES = Filter({
  id: 'bookmarked',
  name: 'Favorite docs',
  subtitle: 'By date of added to favorites',
  icon: Icons.FavoriteIcon,
  emptyIcon: Icons.FavoriteEmptyIcon,
  iconColor: 'yellow',
})

export const TEMPLATE_NOTES = Filter({
  id: 'templates',
  name: 'Templates',
  icon: Icons.TemplateIcon,
  emptyIcon: Icons.TemplateIcon,
  iconColor: 'teal',
})
